import Form from './Form'

export default [
  { path: '/', component: Form }
]
